import React from 'react'
import { useHistory } from 'react-router-dom'

function WelcomeCalendarContainer(props) {
  const history = useHistory()

  const onSkip = async () => {
    await props.onSave({
      completedOnboarding: true,
    })
    history.push('/')
  }

  const onAddCalendar = async () => {
    await props.onSave({
      completedOnboarding: true,
    })
    console.log(`bridge: ${window.bridge}`)
    if ( window.bridge) {
      window.bridge.subscribeToCalendar(
        'https://calendar.google.com/calendar/ical/id04v81g2j22a87c5n0me4ujdk%40group.calendar.google.com/public/basic.ics'
      )
    }
    history.push('/')
  }

  return (
    <div className="screen welcome">
      <div className="navigation-bar">
        <div className="title">Calendar</div>
      </div>
      <div className="content-flex">
        <div style={{ flex: 1 }} />
        <img
          style={{ width: '90vw', maxWidth: 400, margin: 'auto' }}
          src={require('../images/setup_calendar.png')}
          alt="poster"
        />
        <div style={{ flex: 1 }} />
        <p style={{ textAlign: 'center' }}>
          Add the EL-FIT calendar to your phone’s calendar app to keep track of important program
          dates.
        </p>
        <div style={{ flex: 1.8 }} />
        <button className="black block" onClick={onAddCalendar}>
          Add EL-FIT Calendar
        </button>
        <a className="skip" onClick={onSkip}>
          Skip this Step
        </a>
      </div>
    </div>
  )
}

export default WelcomeCalendarContainer
